import { render } from "./TheSave.vue?vue&type=template&id=c771c044&scoped=true"
import script from "./TheSave.vue?vue&type=script&lang=js"
export * from "./TheSave.vue?vue&type=script&lang=js"

import "./TheSave.vue?vue&type=style&index=0&id=c771c044&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c771c044"]])

export default __exports__